import { TextField, Box, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

const MAX_NOTES_LENGTH = 500;

interface NotesTextareaProps {
  disabled?: boolean;
}

export function NotesTextarea({ disabled = false }: NotesTextareaProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name="notes"
      control={control}
      defaultValue=""
      render={({ field, fieldState }) => (
        <Box sx={{ mt: 4, mb: 4 }}>
          <TextField
            label="Ghi chú chung (không bắt buộc)"
            multiline
            minRows={3}
            maxRows={6}
            placeholder="Nhập ghi chú..."
            value={field.value}
            onChange={(e) => {
              field.onChange(e.target.value.slice(0, MAX_NOTES_LENGTH));
            }}
            disabled={disabled}
            helperText={
              <Box
                component="span"
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span>{fieldState.error?.message}</span>
                <Typography
                  variant="caption"
                  color={
                    field.value.length >= MAX_NOTES_LENGTH
                      ? 'error'
                      : 'text.secondary'
                  }
                >
                  {field.value.length}/{MAX_NOTES_LENGTH} ký tự
                </Typography>
              </Box>
            }
            error={!!fieldState.error}
            fullWidth
          />
        </Box>
      )}
    />
  );
}
